<template>
  <div id="app">
    <Layout />
  </div>
</template>

<script>
import Layout from '@/basicLayout/index'
import '@/assets/css/common.css'
export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>

<style lang="less">

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body{
  padding: 0;
  margin: 0;
  background:#FAFAFB;
  width:100%;
}
::-webkit-scrollbar {
    width: 8px;
    height: 10px;
}
::-webkit-scrollbar-thumb {
    background: #909090;
    border-radius: 5px;
}
//detail.vue图片预览
.el-dialog__header {
    padding: 5px 20px 0px !important;
    background: #fff !important;
}
.el-dialog__title{
    display: flex !important;
    justify-content: center !important;
}
.el-dialog__body {
    padding: 5px !important;
    background: #fff !important;
}
.el-dialog__headerbtn{
  top: 10px !important;
}

//分页样式
.el-pagination button:disabled{
    background-color: none !important;
}
.el-pagination .btn-next, .el-pagination .btn-prev{
    background: none !important;
}
.el-pager li {
    background: none !important;
}
</style>
